import { panelSize } from '../../services/panelSize';
import { State } from '../../types/reducer/State';

export function setPanelSize(state: State, value: any): State {
  panelSize.set(value);
  return { ...state, viewAgent: value };
}
